import { RaftOKFail } from "@robotical/raftjs";
import Marty from "./Marty";
import Logger from "../../../services/logger/Logger";
import ColourSensorManualCalibrator from "@robotical/ricjs-robotical-addons/dist/ColourSensorManualCalibrator";

const SHOW_LOGS = true;
const TAG = "CalibrationManager";

export default class CalibrationManager {

    private _jointNames = {
        LeftHip: "LeftHip",
        LeftTwist: "LeftTwist",
        LeftKnee: "LeftKnee",
        RightHip: "RightHip",
        RightTwist: "RightTwist",
        RightKnee: "RightKnee",
        LeftArm: "LeftArm",
        RightArm: "RightArm",
        Eyes: "Eyes",
    };

    constructor(public marty: Marty) {
        this.marty = marty;
    }

    calibrate(cmd: string, joints: string) {
        // Make a list of joints to calibrate on
        const jointList: Array<string> = new Array<string>();
        if (joints === "legs") {
            jointList.push(this._jointNames.LeftHip);
            jointList.push(this._jointNames.LeftTwist);
            jointList.push(this._jointNames.LeftKnee);
            jointList.push(this._jointNames.RightHip);
            jointList.push(this._jointNames.RightTwist);
            jointList.push(this._jointNames.RightKnee);
        } else if (joints === "arms") {
            jointList.push(this._jointNames.LeftArm);
            jointList.push(this._jointNames.RightArm);
        }
        if (joints === "eyes") {
            jointList.push(this._jointNames.Eyes);
        }

        return this._calibrate(cmd, jointList, this._jointNames);
    }

    async _calibrate(
        cmd: string,
        jointList: Array<string>,
        jointNames: { [key: string]: string }
    ) {
        let overallResult = true;
        if (cmd === "set") {
            // Set calibration
            for (const jnt of jointList) {
                try {
                    // Set calibration on joint
                    const cmdUrl = "calibrate/set/" + jnt;
                    const rsl = await this.marty.sendRestMessage(cmdUrl);
                    // saving the calibration... (For the new servo boards it is necessary
                    // to send a "save" command after the calibration ones or any servo
                    // parameter changes in order to save any changes made into nonvolatile storage)
                    const saveCalibCmd = `elem/${jnt}/saveparams`;
                    await this.marty.sendRestMessage(saveCalibCmd);
                    if (rsl.rslt != "ok") overallResult = false;
                } catch (error) {
                    Logger.error(SHOW_LOGS, TAG, `calibrate failed on joint ${jnt} ${error}`);
                }

                // Wait as writing to flash blocks servo access
                // as of v0.0.113 of firmware, the pause is no longer required
                //await new Promise(resolve => setTimeout(resolve, 3000));
            }

            // ensure all joints are enabled
            for (const jnt in jointNames) {
                try {
                    // enable joint
                    const cmdUrl = "servo/" + jnt + "/enable/1";
                    const rsl = await this.marty.sendRestMessage(
                        cmdUrl
                    );
                    if (rsl.rslt != "ok") overallResult = false;
                } catch (error) {
                    Logger.error(SHOW_LOGS, TAG, `enable failed on joint ${jnt} ${error}`);
                }
            }

            // Result
            Logger.info(SHOW_LOGS, TAG, "Set calibration flag to true");
            const rslt = new RaftOKFail();
            rslt.rslt = overallResult ? "ok" : "fail";
            return rslt;
        }
        return false;
    }
}